.progress {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem;
}

.result {
  margin: 0;
  font-weight: 600;
}

.link {
  color: var(--text);
}

.link:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: 2px;
}

/* F-PRV-003: the stages of the run in flight. */
.stages {
  display: flex;
  flex: 1 1 16rem;
  flex-direction: column;
  gap: 0.5rem;
  min-width: 0;
}

.list {
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
  margin: 0;
  padding: 0;
  list-style: none;
}

.stage {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: var(--text-muted);
}

.stage[data-state="done"] {
  color: var(--text);
}

.stage[data-state="current"] {
  color: var(--text);
  font-weight: 600;
}

.marker {
  flex: none;
  width: 1rem;
  height: 1rem;
  border: 2px solid var(--border);
  border-radius: 50%;
}

.stage[data-state="done"] .marker {
  border-color: var(--success);
  background: var(--success);
}

.stage[data-state="current"] .marker {
  border-top-color: var(--border-strong);
  animation: stage-spin 0.8s linear infinite;
}

.step,
.reassurance {
  margin: 0;
  color: var(--text-muted);
}

.visuallyHidden {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}

/* Whoever asked the system not to animate gets a static ring, not a jitter. */
@media (prefers-reduced-motion: reduce) {
  .stage[data-state="current"] .marker {
    animation: none;
  }
}

@keyframes stage-spin {
  to {
    transform: rotate(360deg);
  }
}
